<div class="modal-header">
    <h4
        class="modal-title"
        id="modal-title"
    >
        Confirm {{hasSchedule() ? 'Schedule' : launchType() ? 'ReLaunch' : 'Launch'}}
    </h4>
    <div class="d-flex justify-content-end">
        <button
            type="button"
            aria-label="Close button"
            class="btn-close"
            aria-describedby="modal-title"
            (click)="modal.close({action: 'cancel'})"
        ></button>
    </div>
</div>

<div class="modal-body">
    @if (loading()) {
    <div>
        Loading..
    </div>
    }

    @if (!loading() && code()) {
    <div>
        @if (hasSchedule()) {
        <span>The campaign will be scheduled to {{launchType() ? 're-launched' :'launched'}} at <b>{{getScheduleDateTime()}}</b>
          @if (schedule()?.schedule_date && schedule()?.schedule_time) {
          <span><app-info-popover info="{{ getScheduleDateTime(true) }}"></app-info-popover></span>
          }
        </span>
        }
        @if (!hasSchedule()) {
        <span>The campaign will be {{launchType() ? 're-launched' :'launched'}} <b>now</b></span>
        }
    </div>
    }
</div>
<input
    type="hidden"
    ngbAutofocus
>
<div class="modal-footer">

    @if (hasSchedule()) {
    <button
        class="btn"
        type="button"
        (click)="clearSchedule()"
    >
        Clear Schedule
    </button>
    }

  @if (hasSchedule()) {
  <button
        class="btn"
        type="button"
        (click)="closeWithAction('edit')"
    >
        Edit Schedule
    </button>
  }

<!--  <button-->
<!--        class="btn btn-primary"-->
<!--        type="button"-->
<!--    >-->
<!--        Schedule-->

    <button
        class="btn btn-primary"
        type="button"
        (click)="closeWithAction(hasSchedule() ? 'schedule-launch' : 'launch')"
        [disabled]="loading() || !code()"
    >
        Confirm
    </button>
</div>
